import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import SingleServices from './components/SingleServices';
import SingleBooking from "./components/SingleBooking";

const elemSingleServices = document.getElementById('single_park_services');
const elemSingleBooking = document.getElementById('single_park_booking');

if (elemSingleServices) {
    ReactDOM.render(<SingleServices />, elemSingleServices);
} else {
    console.log('#single_park_services does not exist');
}

if (elemSingleBooking) {
    ReactDOM.render(<SingleBooking />, elemSingleBooking);
} else {
    console.log('#single_park_booking does not exist');
}
